export default "/_next/static/fonts/Graphik-Bold-e22c181f623a92da8f930cceec3eabea.woff2";